import {Component, Input} from '@angular/core';
import {finalize, Subscription} from 'rxjs';
import {HttpClient, HttpEventType} from "@angular/common/http";

@Component({
    selector: 'app-uploader',
    templateUrl: './uploader.component.html',
    styleUrls: ['./uploader.component.scss']
})
export class UploaderComponent {

    @Input()
    requiredFileTypes: string = "application/pdf,image/png";
    private _requiredFileTypesList: string[];
    @Input()
    multiple: boolean = true;
    _valid: boolean = true;
    invalidFilesDescription: string = "";

    files: File[];

    fileName = '';
    uploadProgress: number;
    uploadSub: Subscription;

    constructor(private http: HttpClient) {
        this._requiredFileTypesList = ["application/pdf", "image/png", "image/gif", "image/jpeg", "image/jpg"];
        this.requiredFileTypes = this._requiredFileTypesList.join(',')
        this.files = []
    }

    onFileSelected(event) {
        const addedFiles: File[] = Array.from(event.target.files);
        const validFiles = this.validateExtensions(addedFiles)
        this.files = [...this.files, ...validFiles]
    }

    private validateExtensions(files: File[]): File[] {
        this.invalidFilesDescription = ''
        const invalidFiles = []
        const validFiles = []
        files.forEach(f => {
            if(this.requiredFileTypes.indexOf(f.type) >= 0)
                validFiles.push(f)
            else
                invalidFiles.push(f)
        })
        this._valid = invalidFiles.length < 1
        if (!this._valid) {
            this.invalidFilesDescription = invalidFiles.map(f => f.name).join(',')
        }
        return validFiles;
    }

    remove(file: File) {
        const idx = this.files.indexOf(file)
        this.files.splice(idx, 1);
    }

    cancelUpload() {
        this.uploadSub.unsubscribe();
        this.reset();
    }

    reset() {
        this.uploadProgress = null;
        this.uploadSub = null;
    }

    set fileTypes(types: string[]) {
        this._requiredFileTypesList = types
        this.requiredFileTypes = types.join(',')
    }

    get empty(): boolean {
        return this.files.length < 1
    }

}
